import {useMutation, useQuery} from "@tanstack/react-query";
import {apiGetExamDetail, apiGetExamMyAnswerDetail, apiPostAnswers, apiPostStartExam} from "../../../data/api/form";

export const useStartExam = () => {
    return useMutation({
        mutationFn: ({formId}) =>
            apiPostStartExam(formId),
    })
}

export const useGetExamDetail = (formId, formAnswerId ,params,config) => {
    return useQuery({
        queryKey: ['mission', formId, params, formAnswerId, 'examDetail'],
        queryFn: () => apiGetExamDetail(formId, formAnswerId ,params),
        ...config,
    })
}


export const useGetExamMyAnswerDetail = (formId, runnerId) => {
    return useQuery({
        queryKey: ['mission', formId, runnerId ,'examMyAnswerDetail'],
        queryFn: () => apiGetExamMyAnswerDetail(formId, runnerId)

    })
}

export const usePostSaveAnswers = () => {
    return useMutation({
        mutationFn: ({formId,formAnswerId,data}) =>
            apiPostAnswers(formId,formAnswerId,data),
    })
}